import * as React from 'react'
import { EventFilter } from './EventFilter.tsx'
import { DATETIME_MED_WITH_WEEKDAY } from './ScrollControl.tsx'
import { DateTime } from 'luxon'
import { IEvent } from '../../interfaces/types.ts'
import controlStore from '../../store/controlStore.ts'

interface Props {
	setFilters: (f: string[]) => void
	setFiltersChanged: (c: boolean) => void
	startDate: DateTime
	endDate: DateTime
	events: IEvent[]
}

export const EventOptions: React.FC<Props> = (props) => {
	const {setFilters, setFiltersChanged, startDate, endDate, events} = props
	const isMobile = controlStore(s => s.isOnMobileDevice)

	const changeFilters = (update: string[]) => {
		setFiltersChanged(true)
		setFilters(update)
	}

	const dates = (
		<div className={'flex justify-center items-center w-full py-1 border-y border-neutral-content/30'}>
			{isMobile ? (
				<div className={'text-sm font-semibold text-gray-500'}>
					{startDate?.toFormat('MMM d')} – {endDate?.toFormat('MMM d, yyyy')}
				</div>
			) : (
				<div className={'dateControl flex items-center justify-around w-full'}>
					<div className={'font-bold'}>{startDate?.toLocaleString(DATETIME_MED_WITH_WEEKDAY)}</div>
					<div className={'opacity-50'}>to</div>
					<div className={'font-bold'}>{endDate?.toLocaleString(DATETIME_MED_WITH_WEEKDAY)}</div>
				</div>
			)}
		</div>
	)

    return (
		<div id={'header'} className={'w-full'}>
			<EventFilter onChange={changeFilters} list={events}/>
			{dates}
		</div>
	)
}
